module.exports = __webpack_public_path__ + "static/noordkaap-704b0f9e0cc621626d7e6004aca5faa1.jpg";